import apiService from '../Api'
import IFilter, {
  IPersonnelMovementRequestsAnswer,
  IPersonnelMovementRequestsDescriptivePayload,
  IPersonnelMovementRequestsStorePayload
} from './interfaces'

export default class PersonnelMovementRequestsService {
  async getStep(stepId: number) {
    return apiService.get(`/personnel-movement-requests/step/${stepId}`)
  }

  async getPersonnelMovementRequest(id: number) {
    return apiService.get(`/personnel-movement-requests/${id}`)
  }

  async getAnswers(id: number) {
    return apiService.get(`/personnel-movement-requests/answers/${id}`)
  }

  async list(filter: IFilter) {
    return apiService.get(`/personnel-movement-requests`, { params: filter })
  }

  async store(data: IPersonnelMovementRequestsStorePayload) {
    return apiService.post(`/personnel-movement-requests/`, data)
  }

  async update(id: number, data: IPersonnelMovementRequestsAnswer) {
    return apiService.post(`/personnel-movement-requests/${id}`, data)
  }

  /** Rewrites the first step (requester, e-mail, sector, type) after going back to it. */
  async updateBase(id: number, data: IPersonnelMovementRequestsStorePayload) {
    return apiService.put(`/personnel-movement-requests/${id}`, data)
  }

  /** Answers the role's description step: keep it, or ask RH for changes. */
  async submitDescriptive(id: number, data: IPersonnelMovementRequestsDescriptivePayload) {
    return apiService.post(`/personnel-movement-requests/${id}/descriptive`, data)
  }

  async delete(id: number) {
    return apiService.delete(`/personnel-movement-requests/${id}`)
  }

  async previousStep(id: number) {
    return apiService.post(`/personnel-movement-requests/previous/${id}`)
  }
}
